const HeaderNavSublinks = () => {
  const screenWidth = window.innerWidth;
  const headerNavItems = [...document.querySelectorAll(".menu-item-has-children")];
  const headerNavLinks = [...document.querySelectorAll(".header__nav-link")];
  
  const handleHeaderNavLinks = (event) => {
    headerNavItems.forEach((headerNavItem) => {
      headerNavItem.classList.remove("active");
    });

    event.currentTarget.classList.add("active");
  };

  if (screenWidth >= 1024) {
    if (headerNavItems.length > 0) {
      headerNavItems.forEach((headerNavItem) => {
        headerNavItem.addEventListener("mouseenter", handleHeaderNavLinks);
        headerNavItem.addEventListener("mouseleave", () => {
          headerNavItem.classList.remove("active");
        });
      });
    }
  } else {
    if (headerNavLinks.length > 0) {
      headerNavLinks.forEach((headerNavLink) => {
        const headerNavItem = headerNavLink.parentElement;

        headerNavLink.addEventListener("click", (e) => {
          if (!headerNavItem.classList.contains("active")) {
            e.preventDefault();
          }
          
          headerNavLinks.forEach(link => {
            link.classList.remove("active");
            link.parentElement.classList.remove("active");
          });

          headerNavItem.classList.add("active");
        })
      });
    }
  }
}

export default HeaderNavSublinks;
